export enum HeaderDisplayState {
  SimpleMobile = 'simple_mobile',
  SimpleDesktop = 'simple_desktop',
  WithImageMobile = 'withImage_mobile',
  WithImageDesktop = 'withImage_desktop',
}
